module.exports = __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmEU9fCBc4AMP6lbBP.ddf22a7c.woff2";